var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('focus-trap', {
    attrs: {
      "active": "",
      "tabindex": "0"
    }
  }, [_c('div', {
    staticClass: "video-wrapper"
  }, [_vm.showCloseButton ? _c('button', {
    staticClass: "modal-close-button pure-button",
    attrs: {
      "aria-label": "Close modal",
      "tabindex": "0"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.buttonClose)
    },
    on: {
      "click": _vm.closeModal
    }
  }) : _vm._e(), _c('div', {
    staticClass: "video-container"
  }, [_c('video', {
    ref: "videomedia",
    attrs: {
      "crossorigin": "anonymous",
      "playsinline": ""
    }
  })]), _c('video-player-controls', {
    attrs: {
      "video": _vm.video,
      "videoReference": this.$refs.videomedia
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }